"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _buttons = require("../../../../common/buttons");

var _timeService = _interopRequireDefault(require("../../../../../services/time-service/time-service"));

const VideoDetails = props => {
  const {
    title,
    createdDate,
    onPublish,
    publishButton
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "video-details"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "video-details__info"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "video-details__title"
  }, title), /*#__PURE__*/_react.default.createElement("span", {
    className: "video-details__created-date"
  }, _timeService.default.getFormattedDate(createdDate))), /*#__PURE__*/_react.default.createElement(_buttons.PrimaryButton, {
    className: "video-details__publish-btn",
    onClick: onPublish
  }, publishButton));
};

VideoDetails.propTypes = {
  title: _propTypes.default.string.isRequired,
  createdDate: _propTypes.default.number.isRequired,
  onPublish: _propTypes.default.func.isRequired,
  publishButton: _propTypes.default.string
};
VideoDetails.defaultProps = {
  publishButton: 'Publish'
};
var _default = VideoDetails;
exports.default = _default;